import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // 権限・入力エラーは再試行しない
        if (error instanceof ApiError && error.status < 500 && error.status !== 429) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

/** クエリキーの単一の正 */
export const qk = {
  me: ['me'] as const,
  quota: ['usage', 'quota'] as const,
  notifications: (unreadOnly?: boolean) => ['notifications', { unreadOnly }] as const,
  unreadCount: ['notifications', 'unread-count'] as const,
  activeJobs: ['jobs', 'active'] as const,
  jobs: (params: unknown) => ['jobs', params] as const,
  job: (id: string) => ['jobs', id] as const,
  dashboard: (params: unknown) => ['dashboard', params] as const,

  products: (includeArchived?: boolean) => ['products', { includeArchived }] as const,
  product: (id: string) => ['products', id] as const,

  companies: (params: unknown) => ['companies', params] as const,
  company: (id: string) => ['companies', id] as const,
  companyTimeline: (id: string) => ['companies', id, 'timeline'] as const,
  companyDuplicates: (id: string) => ['companies', id, 'duplicates'] as const,
  companySources: (id: string) => ['companies', id, 'sources'] as const,
  companySecurityCheck: (id: string) => ['companies', id, 'security-check'] as const,

  lists: ['lists'] as const,
  list: (id: string) => ['lists', id] as const,
  tags: ['tags'] as const,
  suppressions: (params: unknown) => ['suppressions', params] as const,

  searchConditions: ['search-conditions'] as const,
  collections: (params: unknown) => ['collections', params] as const,
  collection: (id: string) => ['collections', id] as const,
  collectionCompanies: (id: string, params: unknown) =>
    ['collections', id, 'companies', params] as const,

  templates: (channel?: string) => ['templates', { channel }] as const,
  messages: (params: unknown) => ['messages', params] as const,
  message: (id: string) => ['messages', id] as const,

  campaigns: (params: unknown) => ['campaigns', params] as const,
  campaign: (id: string) => ['campaigns', id] as const,
  campaignProgress: (id: string) => ['campaigns', id, 'progress'] as const,
  campaignTargets: (id: string, params: unknown) => ['campaigns', id, 'targets', params] as const,
  campaignPreview: (id: string, params: unknown) => ['campaigns', id, 'preview', params] as const,
  campaignTracking: (id: string) => ['campaigns', id, 'tracking'] as const,

  sendAttempts: (params: unknown) => ['send-attempts', params] as const,
  sendAttempt: (id: string) => ['send-attempts', id] as const,

  mailerStatus: ['mailer', 'status'] as const,
  mailerThreads: (params: unknown) => ['mailer', 'threads', params] as const,
  mailerThread: (id: string) => ['mailer', 'thread', id] as const,
  googleWorkspace: ['settings', 'google-workspace'] as const,

  inbox: (params: unknown) => ['inbox', params] as const,
  inboxItem: (id: string) => ['inbox', id] as const,
  appointments: (params: unknown) => ['appointments', params] as const,
  activities: (params: unknown) => ['activities', params] as const,

  analyticsSummary: (params: unknown) => ['analytics', 'summary', params] as const,
  analyticsTimeseries: (params: unknown) => ['analytics', 'timeseries', params] as const,
  analyticsBreakdown: (params: unknown) => ['analytics', 'breakdown', params] as const,
  analyticsFunnel: (params: unknown) => ['analytics', 'funnel', params] as const,
  suggestions: (params: unknown) => ['suggestions', params] as const,
  suggestion: (id: string) => ['suggestions', id] as const,

  settings: ['settings'] as const,
  integrations: ['settings', 'integrations'] as const,
  mailAccount: ['settings', 'mail-account'] as const,
  trackingStats: (params: unknown) => ['tracking', 'stats', params] as const,
  trackingEvents: (params: unknown) => ['tracking', 'events', params] as const,
  users: ['users'] as const,
  assignableUsers: ['users', 'assignable'] as const,
  costs: (params: unknown) => ['usage', 'costs', params] as const,
  auditLogs: (params: unknown) => ['logs', 'audit', params] as const,
  executionLogs: (params: unknown) => ['logs', 'executions', params] as const,
};
